import React, {useState, useEffect} from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import MainCard from '../../ui-component/cards/MainCard';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import axiosInstance from '../../axiosInstance';
import { styled } from '@mui/material';
import { height } from '@mui/system';

const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6InEtMjNmYWxldlpoaEQzaG05Q1Fia1A1TVF5VSIsImtpZCI6InEtMjNmYWxldlpoaEQzaG05Q1Fia1A1TVF5VSJ9.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.cVzLdQpbiD5OCLZj0Z28NWcTofjaVywfXvdP6bAnyRin0hcej5rbKQ-o273B6lkm_V8OcKgp0StIIydD9Gw1wF2oeWvHlScYFb-YfTaeOr7i_XI2eyyVQoJzZcnFCVKVYZKFofxU0619NgfNLEkQ5U0vQuRe0EFF4QLoY9KW-ZC1JSG4JzIhBVpslwbqm0Hsjx7p2jf4O1phXVMPfBU6UeTFju0M62lh86x8A4DJHmGrH-n6zk9H6hGqK_SHNpXrbHyxKfNhUzZvduq_8cA2aVy7NJs4-5chvDrju4hTh6Yse6qfTZAyqFN2x_B8IootIRgK8e9RBwNn_BjjGQANrQ" 

const PowerBI = () => {

    const [embedToken, setEmbedToken] = useState('');

  useEffect(() => {
    // Function to authenticate and get embed token
    const getEmbedToken = async () => {
      try {
        // Authenticate and obtain access token
        // const tokenEndpoint = 'https://login.microsoftonline.com/fe3e91ef-4389-4985-ae89-94a65230617a/oauth2/token';
        // const clientId = '240d912d-0112-474e-a724-1d3683fde7dc';
        // const clientSecret = '72f266e8-8290-4c2a-9a07-c50be80c0816';
        // const resourceUrl = 'https://analysis.windows.net/powerbi/api';
        // const tokenData = {
        //   grant_type: 'client_credentials',
        //   client_id: clientId,
        //   client_secret: clientSecret,
        //   resource: resourceUrl
        // };
        // console.log(tokenData, "===========================");
        // const tokenResponse = await axiosInstance.post(tokenEndpoint, null, {
        //     params: tokenData,
        //     headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        //   });
        // const accessToken = tokenResponse.data.access_token;
        // Get embed token for the report
        // const reportId = 'dace8762-e8b5-4be3-bb78-899c501dc210';
        // const workspaceId = 'ED802751-EF77-4939-810B-0CA99009C203';
        // const embedTokenUrl = `https://api.powerbi.com/v1.0/myorg/groups/${workspaceId}/reports/${reportId}/GenerateToken`;
        // const headers = {
        //   Authorization: `Bearer ${'H4sIAAAAAAAEAB2Ut66EVgBE_-W1WCJeYC25IOewZOhYclpytPzvfnY_xejozPz9Y6d3P6b5z58_uP3wce4YSYZ5eyjskbS-FEKVDCRBPplMBiSrfmH1pNwR8tBvH4juhcBE-wYpDXvaTnL7MqfJ4enu4eyyspXglQVUCB-glU1FnywqFDP-2yn2p1ebNoPrxsYHszelMd2iE5yXb_mRS6u03GemvIeiXjwTJiQFj0MxpTnbUD-z6St7f_uSPiRfuQpaR6FOyuFXKl_8jR-bQem0a00YOBc6O44gHabVgo0zLsr7riGG7-UytVM-UiKMxtMf5oODXRZA52beIQ1-JRFnRCWvbHSivAZWqWlyOmWK47emTmSdxQ3IvZ1S5vnvPqkC8qYnR4E6ND7mZGybuvI1FLPlxWcz7yRlbhbQUmPyGGQ52Y60xTDd-j6SjQCjU3eUkIXpV9uFceZvgoWuxjtQqz6GvFjlpIsZRGI8zKb5fPOoUxsUi6YuyilUzcUvKKCBb7Xheklp09Vp1c_eAUhPcybmyf0e-2rC_UTuJzgEX5nNcshc5kYAiOw-OPi37dACju3SEcMON7o3kI0cQSO6ONcPTwRnWeVrETHEbLgXHH6QwJ7X8129P9OnbHtV_PKrTgnghQolb1Dq-BywCsJg9dmZtaLJEzRMBI8Z7gDts1KbjK5pOWvEu6E6v-YTBzTXtS5SZ7rnWzkk48Uer4npfHr4bmwiFVkMvgfJbdEVRGTUYKPR-cEoozMPkNEaPRXa6Y5RpvvU54qnxFzP81kmhlN7Cj3X0gGF2fWT8dYo12UczFLcd2Xi2mDXsuE1GsCL-C7VzcvlX3Liw8E8iyqVa7rm3AKSwzVbMZd52hLCTm8zYWpzJuTYITzZQYmvz6lEIVV16jbpsPz88cMt97SNWnH_zkkSuUsWqYVasOQAF8AW7pPE7VCN27M1A3gOGWol6z2GLzmMNNZGJqZlDOqRuFQ8ssGQ2jLhuOUxJq-KeZGV0iI_WfzI0wbKfZ5xscaGGO1r-1SHWq8MVgTMGng3-Tg1ZD52-HIVOSFABFlqYWGKZXtyMFvd9aE4V4RdhxbfBvrtsm602O7VPpaCg5KdR-spyKCDcKcjyzYYtrobTawKmDE5_cozL0i9e9qgnxdmujuNWqnLJfuu6pzCMeTGUCwv3Cl4ux5mFKHZzfkz0rKZIDvhix0JkmOI30gCs6AwS3bdH75HEyJWXTmYGNTRUi7QeKPM6yrKTMgKmgJfd9Cys6B7519__Yf5nupiUYJfykJ17uM9htSpuznvpwpujFD1f8ptqm-67UvxGytCx2wQC2ZKuqchM8_N32m3_rVLn-adLvjhip1Z6oq-29kYcxzgBPrajciZsregH2Yp2cG70vEq2E87vIyDJ4n2iNgkmDWRbCrZaVclfuYwXsqrBb9GzW4xIGk6k0rsBf353Kt-RDMMlymFCa0l_HraNcOZkNVQfqIyHtOedqxnUdQZEMNgTzE5x0qA0YhA0pRtBzmckx7FQbA5_z5ji-NEMnTmLGeE99u7XkKub1bz867hcu0PAhHF5bqxE0Gyzfp62849vObAaOBbsGLoy_aQ9MuRPsiVDFs_KmJGmoGI8777qL70nV-Qyd-3mtrHhu3C6Z74gLq2mZzpInqlEjNS8h_mf_4FZ73fY0IGAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzEyMTM4NTM5LCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0='}`,
        //   'Content-Type': 'application/json'
        // };

        // const embedTokenResponse = await axiosInstance.post(embedTokenUrl, null, { headers });
        // const embedToken = embedTokenResponse.data.token;
        // // Generate embed URL
        // const embedUrl = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${workspaceId}&token=${embedToken}`;
        // setEmbedUrl(embedUrl);

        
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const generateToken = async () => {
        try {
          const response = await axiosInstance.post('https://api.powerbi.com/v1.0/myorg/GenerateToken',
            {
              datasets: [{ id: 'abf3bbc2-4532-4a4f-9eab-68f30196e9c1' }],
              reports: [{ id: 'dace8762-e8b5-4be3-bb78-899c501dc210' }]
            },
            {
              headers: {
                'accept': '*/*',
                'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8,es;q=0.7',
                'authorization': `Bearer ${token}`,
                'cache-control': 'no-cache',
                'content-type': 'application/json',
                'dnt': '1',
                'origin': 'https://learn.microsoft.com',
                'pragma': 'no-cache',
                'sec-ch-ua': '"Google Chrome";v="123", "Not:A-Brand";v="8", "Chromium";v="123"',
                'sec-ch-ua-mobile': '?0',
                'sec-ch-ua-platform': '"Windows"',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'cors',
                'sec-fetch-site': 'cross-site',
                'user-agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/123.0.0.0 Safari/537.36'
              }
            }
          );
          setEmbedToken(response.data.token)
           // Handle the response data
        } catch (error) {
          console.error(error); // Handle errors
        }
      };

    // Call the function to get embed token
    generateToken();
    // console.log(embedUrl);

  }, []);



    return (
        <React.Fragment>
            <MainCard title="PowerBI" secondary={<CardSecondaryAction />} style={{height: '120vh'}}>
                {embedToken && <PowerBIEmbed
                    
                    embedConfig={{
                        type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                        id: 'dace8762-e8b5-4be3-bb78-899c501dc210',
                        // embedUrl: embedUrl,
                            // 'https://app.powerbi.com/reportEmbed?reportId=dace8762-e8b5-4be3-bb78-899c501dc210&autoAuth=true&ctid=fe3e91ef-4389-4985-ae89-94a65230617a',
                        accessToken: embedToken,
                            // 'H4sIAAAAAAAEAB2Ut66EVgBE_-W1WCJeYC25IOewZOhYclpytPzvfnY_xejozPz9Y6d3P6b5z58_uP3wce4YSYZ5eyjskbS-FEKVDCRBPplMBiSrfmH1pNwR8tBvH4juhcBE-wYpDXvaTnL7MqfJ4enu4eyyspXglQVUCB-glU1FnywqFDP-2yn2p1ebNoPrxsYHszelMd2iE5yXb_mRS6u03GemvIeiXjwTJiQFj0MxpTnbUD-z6St7f_uSPiRfuQpaR6FOyuFXKl_8jR-bQem0a00YOBc6O44gHabVgo0zLsr7riGG7-UytVM-UiKMxtMf5oODXRZA52beIQ1-JRFnRCWvbHSivAZWqWlyOmWK47emTmSdxQ3IvZ1S5vnvPqkC8qYnR4E6ND7mZGybuvI1FLPlxWcz7yRlbhbQUmPyGGQ52Y60xTDd-j6SjQCjU3eUkIXpV9uFceZvgoWuxjtQqz6GvFjlpIsZRGI8zKb5fPOoUxsUi6YuyilUzcUvKKCBb7Xheklp09Vp1c_eAUhPcybmyf0e-2rC_UTuJzgEX5nNcshc5kYAiOw-OPi37dACju3SEcMON7o3kI0cQSO6ONcPTwRnWeVrETHEbLgXHH6QwJ7X8129P9OnbHtV_PKrTgnghQolb1Dq-BywCsJg9dmZtaLJEzRMBI8Z7gDts1KbjK5pOWvEu6E6v-YTBzTXtS5SZ7rnWzkk48Uer4npfHr4bmwiFVkMvgfJbdEVRGTUYKPR-cEoozMPkNEaPRXa6Y5RpvvU54qnxFzP81kmhlN7Cj3X0gGF2fWT8dYo12UczFLcd2Xi2mDXsuE1GsCL-C7VzcvlX3Liw8E8iyqVa7rm3AKSwzVbMZd52hLCTm8zYWpzJuTYITzZQYmvz6lEIVV16jbpsPz88cMt97SNWnH_zkkSuUsWqYVasOQAF8AW7pPE7VCN27M1A3gOGWol6z2GLzmMNNZGJqZlDOqRuFQ8ssGQ2jLhuOUxJq-KeZGV0iI_WfzI0wbKfZ5xscaGGO1r-1SHWq8MVgTMGng3-Tg1ZD52-HIVOSFABFlqYWGKZXtyMFvd9aE4V4RdhxbfBvrtsm602O7VPpaCg5KdR-spyKCDcKcjyzYYtrobTawKmDE5_cozL0i9e9qgnxdmujuNWqnLJfuu6pzCMeTGUCwv3Cl4ux5mFKHZzfkz0rKZIDvhix0JkmOI30gCs6AwS3bdH75HEyJWXTmYGNTRUi7QeKPM6yrKTMgKmgJfd9Cys6B7519__Yf5nupiUYJfykJ17uM9htSpuznvpwpujFD1f8ptqm-67UvxGytCx2wQC2ZKuqchM8_N32m3_rVLn-adLvjhip1Z6oq-29kYcxzgBPrajciZsregH2Yp2cG70vEq2E87vIyDJ4n2iNgkmDWRbCrZaVclfuYwXsqrBb9GzW4xIGk6k0rsBf353Kt-RDMMlymFCa0l_HraNcOZkNVQfqIyHtOedqxnUdQZEMNgTzE5x0qA0YhA0pRtBzmckx7FQbA5_z5ji-NEMnTmLGeE99u7XkKub1bz867hcu0PAhHF5bqxE0Gyzfp62849vObAaOBbsGLoy_aQ9MuRPsiVDFs_KmJGmoGI8777qL70nV-Qyd-3mtrHhu3C6Z74gLq2mZzpInqlEjNS8h_mf_4FZ73fY0IGAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzEyMTM4NTM5LCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0=',
                        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                        settings: {
                            panes: {
                                filters: {
                                    expanded: true,
                                    visible: true
                                }
                            },
                            navContentPaneEnabled: true,
                            // background: models.BackgroundType.Transparent
                        },
                        // filters: [
                        //     {
                        //         $schema: 'http://powerbi.com/product/schema#basic',
                        //         target: {
                        //             table: 'ProductionReport',
                        //             column: 'org_id_id'
                        //         },
                        //         operator: 'In',
                        //         values: ['42']
                        //     }
                        // ],
                        identities: [
                            {
                                username: 'resource1@projectivetech.com',
                                roles: ['Osteoplast']
                            },
                            
                            // Add more users with their respective roles as needed
                        ]
                    }}
                    eventHandlers={
                        new Map([
                            [
                                'loaded',
                                function () {
                                    console.log('Report loaded');
                                }
                            ],
                            [
                                'rendered',
                                function () {
                                    console.log('Report rendered');
                                }
                            ],
                            [
                                'error',
                                function (event) {
                                    console.log(event.detail);
                                }
                            ],
                            ['visualClicked', () => console.log('visual clicked')],
                            ['pageChanged', (event) => console.log(event)]
                        ])
                    }
                    cssClassName={'reportClass'}
                    getEmbeddedComponent={(embeddedReport) => {
                        window.report = embeddedReport;
                    }}
                />}
            </MainCard>
        </React.Fragment>
    );
};

export default PowerBI;
